import React, { useState, useRef } from 'react';
import Button from '@mui/material/Button';
import { useDispatch } from 'react-redux';
import { setImages } from '../../redux/imageSlice';

function LoadPattern(props) {
    const { disabled } = props
    const [jsonData, setJsonData] = useState(null);
    const fileInputRef = useRef(null);
    const dispatch = useDispatch()

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === "application/json") {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const jsonContent = JSON.parse(e.target.result);
                    setJsonData(jsonContent);
                    dispatch(setImages({
                        name: 'loaded_pattern', value: jsonContent
                    }))
                    fileInputRef.current.value = null;
                    console.log("JSON data set:", jsonContent);
                } catch (error) {
                    console.error("Error parsing JSON:", error);
                    alert("Invalid JSON file.");
                }
            };
            reader.readAsText(file);
        } else {
            alert("Please select a valid JSON file.");
        }
    };

    return (
        <div>
            <Button
                variant="outlined"
                color="primary"
                sx={{ textTransform: 'inherit' }}
                onClick={() => fileInputRef.current.click()}
                disabled={disabled}
            >
                Load Pattern
            </Button>
            <input
                type="file"
                accept=".json,application/json"
                style={{ display: 'none' }}
                ref={fileInputRef}
                onChange={handleFileChange}
            />
            {/* Optionally display JSON data */}
            {/* <pre>{JSON.stringify(jsonData, null, 2)}</pre> */}
        </div>
    );
}

export default LoadPattern;
